<template>
  <div class="content">
    <!-- <div v-show="completed" class="complete-btn" @click="openComplete">コンプリート!!</div> -->

    <div class="stamp-container">
      <div class="columns is-mobile is-multiline is-gapless">
        <div v-for="stamp in stamps" class="column is-half" :key="stamp.id">
          <div class="stamp-box">
            <FlipStamp :stamp="stamp" :imprinted="isActive(stamp.id)" @flip="handleFlip"/>
          </div>
        </div>
      </div>
    </div>

    <div class="info mt-5">
      <img src="img/info.svg" alt="">
    </div>

    <div class="links">
      <button class="survey" @click="openSurvey">
        アンケートに回答する
      </button>
    </div>

    <transition name="fade">
      <CompleteButton v-if="completed" @click="openComplete"/>
      <FabButton v-else @click="goQrCamera"/>
    </transition>
  </div>
</template>

<script>
import { mapState, mapGetters } from 'vuex';
import FlipStamp from '../components/FlipStamp.vue';
import FabButton from '../components/FabButton.vue';
import CompleteButton from '../components/CompleteButton.vue';

export default {
  name: 'stamp-page',
  components: {
    FlipStamp,
    FabButton,
    CompleteButton,
  },
  computed: {
    ...mapState(['holder', 'stamps', 'completed']),
    ...mapGetters(['completed']),
    qaLinkUrl() {
      return 'https://docs.google.com/forms/d/e/1FAIpQLSf5ENu-3ZhH1-VFSO1d024f5jj6rqFVr4piVxQLg_JZRsBkeg/viewform?usp=sf_link';
    },
  },

  methods: {
    isActive(id) {
      return this.holder.includes(id);
    },
    handleFlip(id) {
      this.holder.push(id);
      console.log('holder', this.holder);
    },
    goQrCamera() {
      window.dataLayer.push({ event: 'click_qr_btn' }); // gtm
      this.$router.push('/qrcode-reader');
    },
    openComplete() {
      window.dataLayer.push({ event: 'click_complete_btn' }); // gtm
      this.$store.commit('updateShowComplete', true);
    },
    openSurvey() {
      window.dataLayer.push({ event: 'click_survey_btn' }); // gtm
      const newWindow = window.open(this.qaLinkUrl, '_blank');
      newWindow.opener = null;
      newWindow.location = this.qaLinkUrl;
    },
  },
};
</script>

<style lang="scss">
.complete-btn {
  position: absolute;
  top: -8px;
  left: 0;
  right: 0;
  z-index: 1000;
  margin: 0 auto;
  padding: 1.6%;
  width: 40%;
  // height: 10vw;
  border: 1px solid #ea5532;
  border-radius: 1vw;
  background-color: #ea5532;
  outline: none;
  font-size: 4vw;
  color: #fff;
}
.survey {
  background-color: #fff;
  border:#007C76 3px solid;
  width: 80%;
  margin: 0 auto 8vh;
  padding: 1vh;
  border-radius: 1vw;
  color:#007C76;
  font-size: 1rem;
  font-weight: bold;
  letter-spacing: 1px;
}

.fade-enter-active,
.fade-leave-active {
  transition: all .6s ease;
}
.fade-enter, .fade-leave-to {
  opacity: 0;
}

@media screen and (min-width:480px) {
  .complete-btn {
    font-size: 1.6rem;
  }
  .survey{
    border: #007C76 4px solid;
    width: 64%;
    font-size: 3vw;
  }
}
</style>
